<!-- 调拨出库复核操作 -->
<template>
  <div>
    <div>
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
            :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="120px" size="mini" id="mainInfo" :model="sendDataInfo" ref="sendDataInfo"
                    :show-message="false" class="baseForm">
                    <el-row ref="baseForm" v-if="dataActionBox.actionType != 2">
                      <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                        :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                        :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                          v-html="$common.htmlLabel(formOneValue.showField)"></label>
                        <!-- 备注 -->
                        <el-input class="form_codition" v-if="formOneValue.entityField == 'remark'" type="textarea"
                          v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                          :disabled="formOneValue.isChange == 0"></el-input>
                        <!-- 提取方案 -->
                        <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                          :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                          effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                          <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                            :ref="formOneValue.entityField" :id="formOneValue.entityField"
                            @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                            :disabled="formOneValue.isChange == 0">
                            <el-button
                              @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                              slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0"></el-button>
                          </el-input>
                        </el-tooltip>
                        <!-- 检索方案 -->
                        <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                          :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                          effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                          <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                            :ref="formOneValue.entityField" :id="formOneValue.entityField"
                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                            :disabled="formOneValue.isChange == 0">
                            <el-button
                              @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                              slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0"></el-button>
                          </el-input>
                        </el-tooltip>
                        <!-- 复核日期 -->
                        <df-date :isShowLong="false" :isdisabled="formOneValue.isChange == 0"
                          @keyup.enter.native="nextFocus(formOneKey)" v-else-if="formOneValue.fieldType == 'date'"
                          v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                        <el-input :disabled="formOneValue.isChange == 0" v-else
                          @keyup.enter.native="nextFocus(formOneKey)"
                          v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row ref="baseForm" v-if="dataActionBox.actionType == 2">
                      <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                        :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                          v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                        <span v-if="formOneValue.fieldType == 'date'">
                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}</span>

                        <span v-else-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                            sendDataInfo[formOneValue.entityField] }}</a>
                        </span>
                        <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>

                  <!-- 明细 -->
                  <el-form :inline="true" size="mini">
                    <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                      <!-- <el-button type="primary" size="mini" @click="toReview">复核</el-button> -->
                      <el-button type="primary" size="mini" @click="toggleSelection">取消选择</el-button>
                    </div>
                    <el-table :data="sendDataInfo.detailList" border style="width: 100%" :height="mxHeight"
                      class="toReviewTable" ref="multipleTable" :row-class-name="tableRowClassName"
                      @row-click="on_select" @selection-change="handleSelectionChange" size="mini">
                      <el-table-column :selectable="checkboxT" type="selection" width="55"
                        v-if="dataActionBox.actionType != 2"></el-table-column>
                      <el-table-column v-for="(formOneValue, formOneKey) in mxForm" show-overflow-tooltip
                        :min-width="formOneValue.fieldWeight" :key="formOneKey" :prop="formOneValue.entityField"
                        :label="formOneValue.showField" v-if="formOneValue.isShow == 1">
                        <template slot-scope="scope">
                          <!-- 状态 -->
                          <el-tag size="mini" v-if="formOneValue.entityField == 'reviewStatus'">
                            {{ scope.row.reviewStatus == 0 ? '未复核' : '已复核' }}
                          </el-tag>
                          <!-- 显示通用名称 -->
                          <span v-else-if="formOneValue.entityField == 'bgmId'">
                            {{ sendDataInfo.detailList[scope.$index].bgmName }}
                          </span>
                          <!-- 有效期 -->
                          <span v-else-if="formOneValue.fieldType == 'date'">
                            <span v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                              {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                            </span>
                          </span>
                          <span v-else-if="formOneValue.isRift == 1">
                            <a @click="toDetail(sendDataInfo.detailList[scope.$index][formOneValue.riftField])">
                              {{ sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}</a>
                          </span>


                          <span v-else>
                            {{ sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form>
                </div>

              </div>
            </template>
          </v-tabs>
        </el-card>
        <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>

        <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
          @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
      </div>
    </div>

    <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth"
      :modal-append-to-body='true' :append-to-body="true">
      <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth"
        @sendTitle="getExtractName" />
    </el-dialog>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
      :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
        @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
  name: "storeInListAction",
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    ExtractionScheme,
    SearchScheme
  },
  data() {
    //这里存放数据
    return {
      dialogFormVisible: false,
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        rmoutBkeId: "",
        inDate: "",
        coId: "",
        coName: "",
        wosiAccperiod: "",
        wosiDismode: "",
        payMethod: '',
        settleMethod: '',
        credit: '',
        dismode: '',
        wosiId: "",
        wosiPaymode: "",
        movmInstid: '',
        movmOutstid: "",
        storeId: '',

        detailList: [],
        remark: '',
      },

      showTabs: "",
      formDataList: [],
      dictionariesData: {},
      userOneList: [],


      actionIndex: "",
      ishowRew: true,
      exTitle: "", //提取
      DialogExtract: false,
      exWidth: "0",
      exId: "",
      ppId: "",
      mxHeight: 0,
      mxForm: [],
      tabForm: [],
      footForm: [],
      sField: '', // 赋值字段
      fField: '', //焦点字段
      nosField: '', // 不可赋值字段
      inputel: '', //所有input对象
      seTitle: "", //检索
      DialogVisible: false,
      seId: 0,
      seType: "",
      seIndex: 0,
      seWidth: '',
      parentSearchData: {},
      selectedRow: [], // 当前已选择行
      multipleSelection: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "sendDataInfo.detailList": {
      handler: function (newValue, oldValue) {
        this.sendDataInfo.detailList = newValue;
        // 总条目数
        this.sendDataInfo.totalCount = newValue.length ? newValue.length : 0
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    tabHeight(val) {
      this.mxHeight = val
    },
    // 检索Id, 索引(表格中), 标识
    //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
    openSearch(sId, index, type, sField, fField, nosField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField
      this.fField = fField
      this.nosField = nosField
      this.parentSearchData[type] = this.sendDataInfo[type]
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById('mainInfo')
      if (el) this.inputel = el.getElementsByTagName('input')
    },
    changeInputModel(val) {
      // debuggger
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
      this.$nextTick(() => {
        this.nextFocus(this.seIndex)
      })
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= (this.inputel.length - 1)) {
        if (this.sendDataInfo.detailList.length > 0) return
      }
      var aindex = index + 1
      if (this.inputel[aindex].title == 'second') {
        aindex += 1
      }
      if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
        this.nextFocus(aindex)
        return
      }
      this.inputel[aindex].focus()
    },
    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == '') {
          this.inputel[index].focus()
          break
        }
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    showPrintPlan() { // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
      } else {
        return
      }
    },
    // 子组件穿透方法
    toDetail(orderId) {
      if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
      else this.$parent.$parent.$parent.toDetail(orderId)
    },
    // 触发提取方案
    openExComponents(e, index, type) {
      console.log(e);
      this.exId = e;
      this.seIndex = index;
      this.seType = type;
      this.DialogExtract = true;
    },
    // 获取 提取单数据
    async getExData(res) {
      let val = JSON.parse(JSON.stringify(res));
      // console.log(val);
      if (val != "" || val != undefined) {
        this.sendDataInfo.detailList = []
        for (let key in val) {
          if (key == "arrlistbychen") {
            for (const key1 in val.arrlistbychen) {
              this.$set(this.sendDataInfo.detailList, key1, val.arrlistbychen[key1])
              for (const key2 in val.arrlistbychen[key1]) {
                this.$set(this.sendDataInfo.detailList[key1], key2, val.arrlistbychen[key1][key2])
              }
            }
            this.sendDataInfo.detailList.forEach((items, keys) => {
              this.sendDataInfo.detailList[keys].reviewStatus = 0;
            });
          } else {
            this.$set(this.sendDataInfo, key, val[key])
          }
        }

        this.DialogExtract = false;
        this.$nextTick(() => {
          this.nextFocus(this.seIndex)
        })
      }
    },
    getExWidth(e) {
      this.exWidth = e + "%";
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    //保存
    async sendDataAction() {
      // if (!this.sendDataInfo.rmoutBkeId) {
      //   this.$message({
      //     message: "请选择入库申请单进行复核",
      //     type: "error",
      //   });
      //   return false;
      // }
      // for (let i = 0; i < this.sendDataInfo.detailList.length; i++) {
      //   const item = this.sendDataInfo.detailList[i]
      //   if (item.reviewStatus == 0) {
      //     this.$message({
      //       message: "明细必须全部复核完毕才能新增",
      //       type: "error",
      //     });
      //     return false;
      //   }

      // }
      console.log(this.sendDataInfo, 99999);
      if (this.dataActionBox.actionType == 0) {
        //新增
        var responseData = await this.$http.moveInAdd(this.sendDataInfo);
      }else if(this.dataActionBox.actionType == 1){
        // 编辑
        var responseData = await this.$http.moveInModifyMaster(this.sendDataInfo);
      }

      if (responseData && responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit('drawerCancel',1)
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取复核人
    async getSpecialUser() {
      let responseData = await this.$http.getSpecialUser({
        opmReviewer: 1
      });
      if (responseData && responseData.status == 200) {
        this.userOneList = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },


    initActionBox() {
      this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$common.delOrderInfo(this.sendDataInfo.rmoutBkeId)
        this.$emit('drawerCancel')
        this.init()
      }).catch(() => { })

    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "rgApplyauxinfAdd") {
          this.sendDataInfo[key] = {};
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = "";
          }
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      this.sendDataInfo.detailList = [];
    },

    //复选框
    checkboxT(row, rowIndex) {
      if (this.sendDataInfo.detailList[rowIndex].reviewStatus == 1) {
        return false; //禁用
      } else {
        return true; //不禁用
      }
    },
    //点击行选中复选框
    on_select(val) {
      this.$refs.multipleTable.toggleRowSelection(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    // 添加索引
    tableRowClassName(row) {
      // 给每条数据添加一个索引
      row.row.index = row.rowIndex;
    },
    //复核
    toReview() {
      if (this.sendDataInfo.detailList.length == 0) {
        return this.$message({
          type: "warning",
          message: "暂无复核明细",
        });
      } else if (this.multipleSelection.length == 0) {
        return this.$message({
          type: "warning",
          message: "请先选中明细",
        });
      }
      //拿到选中的数据
      let val = this.multipleSelection;
      //如果选中数据存在
      if (val) {
        //将选中数据遍历
        val.forEach((val, index) => {
          //遍历源数据
          this.sendDataInfo.detailList.forEach((v, i) => {
            //如果选中数据和源数据的某一条唯一标识符相等，更改对应的源数据
            if (val.index === v.index) {
              this.sendDataInfo.detailList[index].reviewStatus = 1;
              // console.log(this.sendDataInfo.detailList[i])
            }
          });
        });
      }
      this.sendDataInfo.detailList.splice(1, 0);
      this.$message({
        type: "success",
        message: "已复核",
      });
    },
    //取消选择
    toggleSelection() {
      if (this.multipleSelection.length == 0) {
        return this.$message({
          type: "warning",
          message: "暂无选择明细",
        });
      }
      this.$refs.multipleTable.clearSelection();
    },





    //父级传入
    openBox() {

      this.dataActionBox.actionType = this.actionData.cate

      this.formDataList = this.actionData.formData
      var oldData = this.actionData.oldData
      this.showTabs = this.actionData.formData[0].jciName
      this.filterMainField()
      this.init();
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增";
        this.dataActionBox.openMode = "ltr";
        this.sendDataInfo.inDate = this.$moment().valueOf();
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = '编辑'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }

      } else if (this.dataActionBox.actionType == 2) {
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.$refs['tree'].init(this.sendDataInfo.worcmId)
            this.mxHeight = this.$common.getHeight()
          }
          this.initFocus();
        }, 16.7)
      })

    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = []
      this.formDataList.forEach(item => {
        if (item.jciType == 1) {
          mainFormList.push(item)
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
        }
      })
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key))
        this.tabForm[i].jurconfigform = []
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
        }
      })
      var arr = [{ entityField: "detailList" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox()
    })
    this.ppId = "rmoutBkeId";
    this.getSpecialUser();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput()
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.mb {
  margin-bottom: 0;
}

::v-deep .toReviewTable tr td:first-child .cell,
::v-deep .toReviewTable tr th:first-child .cell {
  text-align: center;
}

::v-deep .toReviewTable .el-checkbox__inner {
  width: 20px;
  height: 20px;
}

::v-deep .toReviewTable .el-checkbox__inner::after {
  height: 8px;
  left: 6px;
  top: 2px;
  width: 5px;
}

::v-deep .toReviewTable .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  height: 2px;
  left: 0;
  right: 0;
  top: 7px;
}
</style>
